import 'react-datepicker/dist/react-datepicker.css'
import 'react-loading-skeleton/dist/skeleton.css'
import 'mapbox-gl/dist/mapbox-gl.css'

import React, { useEffect } from 'react'
import { I18nextProvider } from 'react-i18next'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { GoogleOAuthProvider } from '@react-oauth/google'
import {
   ACCESS_TOKEN_KEY_NAME,
   REFRESH_TOKEN_KEY_NAME,
   useGetRefreshTokensAPI
} from '@flowwai-frontend/bps-officer-web/login'
import { CookieAuthSessionProvider } from '@flowwai-frontend/shared/auth/web'
import { Config } from '@flowwai-frontend/bps-officer-web/env-config'
import {
   DynamicFeatureTogglesProvider,
   FeatureToggleAppId
} from '@flowwai-frontend/shared-web/feature-toggles'
import {
   BrowserCompatibility,
   CrossBrowserBanner,
   ErrorBoundary,
   SuspenseWithLoader
} from '@flowwai-frontend/shared/common-components'
import {
   disableConsoleObjects,
   guardEmbedding
} from '@flowwai-frontend/shared/utils/common'
import { initSentry } from '@flowwai-frontend/shared/utils/web'
import { inspect } from '@xstate/inspect'
import {
   BuildNowLogo,
   LaunchingModeController
} from '@flowwai-frontend/shared-web/common/ui'

import i18n from '../i18n'

import WebAppCompatibleView from './components/WebAppCompatibleView/WebAppCompatibleView'
import './autoScrolling.css'
import './commonStyles.css'
import './keyframes.css'
import './styles.css'

const queryClient = new QueryClient()

export const initXstateDevTools = () => {
   process.env.NODE_ENV === 'development' &&
      inspect({
         iframe: false
      })
}

// Initialize Sentry
initSentry()

const App = () => {
   const getRefreshTokenAPI = useGetRefreshTokensAPI()

   useEffect(() => {
      guardEmbedding()
      disableConsoleObjects()
   }, [])

   if (Config?.ENABLE_LAUNCHING_MODE === 'true')
      return <LaunchingModeController />

   return (
      <BrowserCompatibility appLogo={BuildNowLogo}>
         <ErrorBoundary shouldShowActionItem={false} shouldWrapWithThemeContext>
            <DynamicFeatureTogglesProvider
               appId={FeatureToggleAppId.BpsOfficer}
            >
               <GoogleOAuthProvider clientId={Config.GOOGLE_CLIENT_ID}>
                  <QueryClientProvider client={queryClient}>
                     <SuspenseWithLoader>
                        <I18nextProvider i18n={i18n}>
                           <CookieAuthSessionProvider
                              cookieDetails={{
                                 refreshTokensAPI: getRefreshTokenAPI,
                                 accessTokenKeyName: ACCESS_TOKEN_KEY_NAME,
                                 refreshTokenKeyName: REFRESH_TOKEN_KEY_NAME
                              }}
                           >
                              <WebAppCompatibleView />
                           </CookieAuthSessionProvider>
                           <CrossBrowserBanner />

                           {/* END: routes */}
                        </I18nextProvider>
                     </SuspenseWithLoader>
                  </QueryClientProvider>
               </GoogleOAuthProvider>
            </DynamicFeatureTogglesProvider>
         </ErrorBoundary>
      </BrowserCompatibility>
   )
}

export default App
